import { GetServerSideProps } from 'next'
import { ForgotpwdPage } from '@/features/user/forgotpwd/components/ForgotpwdPage'
import { UserInfo } from '@/types'
import auth from '@/utils/auth'
import { ApiClient } from '@/libs/api'
export default ForgotpwdPage

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { req, res } = ctx
  if (!(await auth.isLogin(req, res))) {
    return { props: { email: '' } }
  }
  const client = new ApiClient(req, res)
  const response = await client.get<UserInfo>('/user/info')
  return {
    props: { email: response.email || '' },
  }
}
